<section class="grid gap-4 min-h-full">
  <mat-card class="rounded-3xl border border-slate-200 p-4 shadow-lg shadow-slate-200/60">
    <div class="mb-3 flex items-center justify-between gap-2">
      <h3 class="text-lg font-semibold text-slate-900">Client configurations</h3>

      @if (canManage()) {
        <button mat-icon-button type="button" (click)="manageConfiguration.emit({ action: ClientActions.Create })">
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>

    @if (data().length === 0) {
      <p class="text-sm text-slate-500">No configurations found.</p>
    } @else {
      <div class="grid gap-3">
        @for (item of data(); track item.id) {
          <div class="rounded-2xl border border-slate-200 p-3 text-sm">
            @if (canManage()) {
              <div class="mb-2 flex justify-end gap-2">
                <button
                  mat-icon-button
                  type="button"
                  (click)="manageConfiguration.emit({ configuration: item, action: ClientActions.Edit })">
                  <mat-icon>edit</mat-icon>
                </button>

                <button
                  mat-icon-button
                  type="button"
                  (click)="manageConfiguration.emit({ configuration: item, action: ClientActions.Toggled })"
                  [matTooltip]="item.isActive ? 'Deactivate' : 'Activate'">
                  <mat-icon>
                    {{ item.isActive ? 'block' : 'check_circle' }}
                  </mat-icon>
                </button>
              </div>
            }

            <p>
              <span class="font-semibold">Status:</span>
              {{ item.isActive ? 'Active' : 'Inactive' }}
            </p>

            <p><span class="font-semibold">Logo:</span> {{ item.logo ?? '-' }}</p>
            <p><span class="font-semibold">Notification email:</span> {{ item.notificationEmail ?? '-' }}</p>
            <p><span class="font-semibold">Max dependents:</span> {{ item.maxNumberOfDependents ?? '-' }}</p>
            <p><span class="font-semibold">Client portal:</span> {{ item.canAccessClientPortal ? 'Enabled' : 'Disabled' }}</p>
            <p><span class="font-semibold">Face to face cases allowed:</span> {{ item.faceToFaceCasesAllowed ?? '-' }}</p>
            <p><span class="font-semibold">Telephonic cases allowed (% of headcount):</span> {{ item.telephonicCasesAllowedPercentageOfHeadcount ?? '-' }}</p>
            <p><span class="font-semibold">Sessions allowed per case:</span> {{ item.sessionsAllowedPerCase ?? '-' }}</p>
          </div>
        }
      </div>
    }
  </mat-card>
</section>